import { action, flow, makeObservable, observable } from 'mobx';
import { GlobalStore } from '@roc/feature-app-core';
import { downloadDocument } from '@roc/feature-utils';
import { PropertyDocumentDataService } from '../service/propertyDocumentDataService';

export class PropertyDocumentDataStore {
  globalStore: GlobalStore;
  private propertyDocumentDataService: PropertyDocumentDataService;

  propertyDocumentDataId: number | null;
  addendumFileName: string | null;
  propertyDocumentDataPreviewData: any;

  constructor(globalStore: GlobalStore) {
    this.globalStore = globalStore;
    this.propertyDocumentDataService = new PropertyDocumentDataService();
    this.propertyDocumentDataId = null;
    this.addendumFileName = null;
    this.propertyDocumentDataPreviewData = null;

    makeObservable(this, {
      propertyDocumentDataId: observable,
      addendumFileName: observable,
      propertyDocumentDataPreviewData: observable,
      upload: flow,
      download: flow,
      fetch: flow,
      preview: flow,
      reset: action,
      clearPreview: action,
    });
  }

  reset() {
    this.propertyDocumentDataId = null;
    this.addendumFileName = null;
    this.propertyDocumentDataPreviewData = null;
  }

  clearPreview() {
    this.propertyDocumentDataPreviewData = null;
  }

  *upload(file: File, loanId: number, propertyId: number, taskId: number, type: string) {
    try {
      const response = yield this.propertyDocumentDataService.upload(
        file,
        loanId,
        propertyId,
        taskId,
        type
      );
      this.propertyDocumentDataId = response?.data ?? null;
      this.addendumFileName = file.name;
      return this.propertyDocumentDataId;
    } catch {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'An error occurred while uploading the property document data file.',
      });
      throw new Error();
    }
  }

  *download(propertyDocumentDataId: number) {
    try {
      const response = yield this.propertyDocumentDataService.download(propertyDocumentDataId);
      downloadDocument(response?.data, response?.headers, 'download');
    } catch {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'An error occurred while downloading the property document data file.',
      });
    }
  }

  *fetch(loanId: number, propertyId: number, type: string) {
    try {
      const response = yield this.propertyDocumentDataService.fetch(loanId, propertyId, type);
      const data = response?.data?.data;
      this.propertyDocumentDataId = data?.propertyDocumentDataId ?? null;
      this.addendumFileName = data?.fileName ?? null;
    } catch {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'An error occurred while loading the property document data file.',
      });
    }
  }

  *preview(propertyDocumentDataId: number) {
    try {
      this.propertyDocumentDataPreviewData = null;
      const response = yield this.propertyDocumentDataService.download(propertyDocumentDataId);
      this.propertyDocumentDataPreviewData = response;
    } catch {
      this.globalStore.notificationStore.showErrorNotification({
        message: 'An error occurred while loading the document preview.',
      });
    }
  }
}
